class Overlay {
    constructor(id) {
        this.id = id;

        this.elem = null;
        this.overlayInner = null;
        this.closeBtn =  null;
        this.hasContent = false;
        this.content = null;
        this.isOpen = false;
        this.overlayElements = null;
        this.closeIcon = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 44 40" style="enable-background:new 0 0 44 40;" xml:space="preserve"> <polygon class="fill-colored-third" points="32.5,27.5 29,31 22.6,24.6 16.6,31 13,27.6 19.1,21.1 12.7,14.7 16.2,11.1 22.5,17.5 28.4,11.2 32,14.6 26,21"/></svg>';
        this.init();
    }

    init() {
        this.overlayElements = document.getElementsByClassName(this.id);
        this.addOverlayElement();
    }

    addOverlayElement() {
        this.elem = document.getElementById(this.id);
        if(!this.elem) {
            this.elem = document.createElement('div');
            this.elem.id = this.id;

            this.overlayInner = document.createElement('div');
            this.overlayInner.id = this.id + '-wrapper';
            this.overlayInner.classList.add('overlay-wrapper');

            this.contentWrapper = document.createElement('div');
            this.contentWrapper.id = this.id + '-content-wrapper';
            this.contentWrapper.classList.add(this.id + '-content-wrapper');

            this.closeBtn = document.createElement('button');
            this.closeBtn.id = this.id + '-closeBtn';
            this.closeBtn.classList.add('closeBtn');
            this.closeBtn.innerHTML = '<span class="icon">'+this.closeIcon+'</span>';

            this.overlayInner.appendChild(this.closeBtn);
            this.overlayInner.appendChild(this.contentWrapper);

            this.elem.appendChild(this.overlayInner);

            document.body.appendChild(this.elem);

            this.initListeners();

        }
        this.elem.classList.add('overlay-main');
        this.elem.classList.add('bg-colored-main');
    }

    initListeners() {
        this.closeBtn.addEventListener('click', (e) => {
            this.closeOverlay();
        });

        document.addEventListener('keyup', e => {
            if(this.isOpen && (e.key === 'Escape' || e.key === 'Esc')) {
                this.closeOverlay();
            }
        });

        this.elem.addEventListener('click', e => {
            if(this.isOpen) {this.closeOverlay()}
        });

        if(this.overlayElements) {
            for(let i = 0; i < this.overlayElements.length; i++) {
                let overlayElem = this.overlayElements.item(i);
                overlayElem.addEventListener('click', e => {
                    if(e.target.tagName !== "A") {
                        let overlayElemClone = this.overlayElements.item(i).cloneNode(true);
                        overlayElemClone.classList.add('loading');
                        let overlayImg = overlayElemClone.getAttribute('data-overlay');
                        this.showInOverlay(overlayElemClone, () => {
                            if(overlayImg) {
                                let img = overlayElemClone.querySelector('img');
                                img.onload = () => {
                                    overlayElemClone.classList.remove('loading')
                                };
                                img.src = overlayImg;
                            } else {
                                overlayElemClone.classList.remove('loading');
                            }
                        });
                    }
                })
            }
        }
    }

    closeOverlay() {
        this.elem.classList.remove('open');
        let childrens = this.contentWrapper.children;
        if(childrens.length > 0) {
            for(let i = 0; i < childrens.length; i++) {
                this.contentWrapper.removeChild(childrens[i]);
            }
            this.content = null;
            this.hasContent = false;
            this.isOpen = true;
        }
    }

    showInOverlay(elToShow, fallback=null) {
        if(elToShow) {
            this.content = elToShow;
            let imagetag = elToShow.getElementsByTagName('img')[0];
            if(elToShow.classList.contains('lazy-bg') && imagetag) {
                //removes lazy loaded image
                elToShow.removeChild(elToShow.getElementsByClassName('lazyImage')[0]);
                imagetag.src = elToShow.getAttribute('data-lazy');
            }
            this.contentWrapper.appendChild(elToShow);
            this.hasContent = true;
            let links = this.contentWrapper.getElementsByTagName('a');
            if(links) {
                for(let i = 0; i < links.length; i++) {
                    links.item(i).addEventListener('click', e => {
                        e.stopPropagation();
                    });
                }
            }

            this.openOverlay(fallback);
        }
    }

    openOverlay(fallback=null) {
        this.elem.classList.add('open');
        this.isOpen = true;
        if(fallback) {fallback(this.content)}

    }
}

export default Overlay;
